"use client"

import { Crisp } from "crisp-sdk-web"
import config from "@/config"
import { UserRound } from "lucide-react"

const ButtonSupport: React.FC<{ className?: string }> = ({ className }): React.ReactElement => {
  const handleClick = () => {
    if (config.crisp?.id) {
      Crisp.chat.show()
      Crisp.chat.open()
    } else if (config.resend?.supportEmail) {
      // open default email client in new window with "need help with ${config.appName}" as subject
      window.open(
        `mailto:${config.resend.supportEmail}?subject=Need help with ${config.appName}`,
        "_blank"
      )
    }
  }

  return (
    <button
      onClick={handleClick}
      title="Chat with support"
      className={`flex flex-wrap ${className} gap-2`}
    >
      <UserRound className="size-4" />
      Support
    </button>
  )
}

export default ButtonSupport